import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <footer className="no-print bg-navy-800 dark:bg-navy-900 mt-auto">
      <div className="max-w-7xl mx-auto container-padding py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center space-x-2 mb-4 hover:opacity-80 transition-opacity">
              <div className="w-8 h-8 flex items-center justify-center bg-gold-600 rounded-lg">
                <svg className="w-5 h-5 text-navy-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
              </div>
              <span className="font-serif font-bold text-white">RONDANINI</span>
            </Link>
            <p className="text-sm text-gray-400 mb-4">
              Professional financial education for practitioners, analysts, and students worldwide.
            </p>
            <p className="text-xs text-gray-500">
              Over 70 years of combined institutional experience.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-semibold text-white mb-4">Navigation</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>
                <Link to="/" className="hover:text-gold-400 transition-colors">Home</Link>
              </li>
              <li>
                <a href="/cashfx" className="hover:text-gold-400 transition-colors">FX Cash Products</a>
              </li>
              <li>
                <Link to="/series/fx-instruments" className="hover:text-gold-400 transition-colors">FX Instruments</Link>
              </li>
              <li>
                <Link to="/series/interest-rates" className="hover:text-gold-400 transition-colors">Interest Rates</Link>
              </li>
              <li>
                <Link to="/series/risk-management" className="hover:text-gold-400 transition-colors">Risk Management</Link>
              </li>
              <li>
                <Link to="/treasury-risk-learning-infrastructure" className="hover:text-gold-400 transition-colors">Treasury learning infrastructure</Link>
              </li>
              <li>
                <Link to="/trusted-treasury-voices" className="hover:text-gold-400 transition-colors">Trusted treasury sources</Link>
              </li>
              <li>
                <Link to="/vendor-evaluation-checklist" className="hover:text-gold-400 transition-colors">Vendor checklist</Link>
              </li>
              <li>
                <Link to="/problems-solved" className="hover:text-gold-400 transition-colors">Problems solved</Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-semibold text-white mb-4">Support</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>
                <a href="mailto:support@rondanini.com" className="hover:text-gold-400 transition-colors">Contact Support</a>
              </li>
              <li>
                <a href="mailto:erratafx@rondanini.com" className="hover:text-gold-400 transition-colors">Report Errata</a>
              </li>
              <li>
                <a href="https://www.rondanini.net" target="_blank" rel="noopener noreferrer" className="hover:text-gold-400 transition-colors">Main Website</a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold text-white mb-4">Legal</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>
                <Link to="/terms-of-service" className="hover:text-gold-400 transition-colors">Terms of Service</Link>
              </li>
              <li>
                <Link to="/subscription-terms" className="hover:text-gold-400 transition-colors">Subscription Terms</Link>
              </li>
              <li>
                <Link to="/fair-use" className="hover:text-gold-400 transition-colors">Fair Use &amp; Access Policy</Link>
              </li>
              <li>
                <Link to="/refund-policy" className="hover:text-gold-400 transition-colors">Refund policy</Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="hover:text-gold-400 transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <span className="text-gray-500">License Agreement</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-navy-700">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-sm text-gray-400">
              © 2026 Rondanini Publishing Ltd. All rights reserved.
            </div>
            <div className="text-xs text-gray-500">
              Company registered in England and Wales No. 16548159
            </div>
            <div className="flex items-center space-x-2">
              <span className="text-xs text-gray-500">learn.rondanini.com</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
